if (!customElements.get('p22-stock-grid')) {
  customElements.define(
    'p22-stock-grid',
    class P22StockGrid extends HTMLElement {
      connectedCallback() {
        if (this.completed || this.loading || Number(this.dataset.p22Pages) <= 1) return;
        this.loading = true;
        this.requestController = new AbortController();
        const requestVersion = (this.requestVersion || 0) + 1;
        this.requestVersion = requestVersion;
        this.loadRemainingPages(this.requestController.signal, requestVersion).finally(() => {
          this.loading = false;
        });
      }

      disconnectedCallback() {
        this.requestController?.abort();
        this.requestController = undefined;
        this.loading = false;
        this.requestVersion = (this.requestVersion || 0) + 1;
      }

      async loadRemainingPages(signal, requestVersion) {
        const grid = this.querySelector('#product-grid');
        const sectionId = this.dataset.p22SectionId;
        const totalPages = Number(this.dataset.p22Pages);
        const currentPage = Number(this.dataset.p22CurrentPage);
        if (!grid || !sectionId || totalPages <= 1 || !currentPage) return;

        const cardsByPage = new Map([[currentPage, Array.from(grid.querySelectorAll(':scope > li[data-product-id]'))]]);
        const pagesToLoad = Array.from({ length: totalPages }, (_, index) => index + 1).filter(
          (page) => page !== currentPage
        );
        try {
          const loadedPages = await this.fetchPages(pagesToLoad, sectionId, signal);
          loadedPages.forEach((cards, page) => cardsByPage.set(page, cards));
        } catch (error) {
          if (error.name !== 'AbortError') console.warn(error);
          return;
        }

        if (this.isConnected === false || this.requestVersion !== requestVersion) return;
        const orderedCards = Array.from({ length: totalPages }, (_, index) => cardsByPage.get(index + 1));
        if (orderedCards.some((pageCards) => !pageCards)) return;

        const uniqueCards = [];
        const productIds = new Set();
        orderedCards.flat().forEach((card) => {
          const productId = card.dataset.productId;
          if (!productId || productIds.has(productId)) return;
          productIds.add(productId);
          uniqueCards.push(card);
        });

        const availableCards = uniqueCards.filter((card) => card.dataset.available === 'true');
        const unavailableCards = uniqueCards.filter((card) => card.dataset.available !== 'true');
        grid.replaceChildren(...availableCards, ...unavailableCards);
        this.querySelector('.pagination-wrapper')?.remove();
        this.completed = true;
      }

      async fetchPages(pages, sectionId, signal) {
        const loadedPages = new Map();
        let nextPageIndex = 0;
        const worker = async () => {
          while (nextPageIndex < pages.length) {
            const page = pages[nextPageIndex];
            nextPageIndex += 1;
            const url = new URL(window.location.href);
            url.searchParams.set('section_id', sectionId);
            url.searchParams.set('page', page);
            const response = await fetch(url.toString(), { signal });
            if (!response.ok) throw new Error(`Unable to load collection page ${page}.`);
            const html = await response.text();
            const document = new DOMParser().parseFromString(html, 'text/html');
            const pageGrid = document.querySelector('p22-stock-grid #product-grid');
            if (!pageGrid) throw new Error(`Collection page ${page} did not return a product grid.`);
            loadedPages.set(page, Array.from(pageGrid.querySelectorAll(':scope > li[data-product-id]')));
          }
        };
        await Promise.all(Array.from({ length: Math.min(3, pages.length) }, worker));
        return loadedPages;
      }
    }
  );
}
